(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["video/outer-watchlater"] = factory();
	else
		root["video/outer-watchlater"] = factory();
})(globalThis, () => {
return 